// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgCheckIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M8.997 18a1 1 0 0 1-.71-.29l-3.997-4a1.004 1.004 0 0 1 1.42-1.42l3.287 3.3 9.286-9.3a1.003 1.003 0 1 1 1.419 1.42l-9.995 10a1 1 0 0 1-.71.29"
    />
  </g>
);
export default SvgCheckIcon;
SvgCheckIcon.displayName = 'SvgCheckIcon';
